import React from 'react'
import { dialogTypes } from '@/dialogs'
import { Column } from '@/components/BsrsGrid'
import { PropertyRenderer } from '@/components/changeRequests'
import { useLocalization } from '@/hooks/localization'

export const BankAccountNumbers = React.memo(function BankAccountNumbers ({ dataSource, readonly }) {
  const { localize } = useLocalization()
  return (
    <PropertyRenderer name='bankAccountNumbers' inputType='grid' dataSource={dataSource}
      readonly={readonly} addButtonLabel='Institutions.AddBankAccountNumber'
      detailDialog={{ dialogType: dialogTypes.bankAccountNumber }}>
      <Column field='accountType' title={localize('Institutions.AccountType')} filter='numeric' />
      <Column field='accountNumber' title={localize('Institutions.AccountNumber')} maxLength={200} />
    </PropertyRenderer>
  )
})



// WEBPACK FOOTER //
// ./src/components/demographics/bankAccountNumbers.js